import { Timestamp } from "firebase/firestore"; // Assuming Firestore from Firebase

export const DateHelper = {
    GetFirstDayOfMonthByDate: function (date) {
        const year = date.getFullYear();
        const month = date.getMonth();
        return this.GetFirstDayOfMonth(year, month);
    },

    GetLastDayOfMonthByDate: function (date) {
        const year = date.getFullYear();
        const month = date.getMonth();
        return this.GetLastDayOfMonth(year, month);
    },

    GetFirstDayOfMonth: function (year, month) {
        return new Date(year, month, 1);
    },

    GetLastDayOfMonth: function (year, month) {
        let lastDayOfMonth = new Date(year, month + 1, 0).getDate();
        return new Date(year, month, lastDayOfMonth);
    },

    AddMonths: function (date, value) {
        let newDate = new Date(date);
        newDate.setMonth(date.getMonth() + value);
        return newDate;
    },


    DateToPast: function (date) {
        let dta = Math.floor(Math.abs(new Date() - new Date(date)) / 1000 / 60);

        if (dta < 60) {
            return `${Math.floor(dta)} minutos atrás`;
        } else {
            dta = dta / 60;

            if (Math.floor(dta) < 24) {
                return `${Math.floor(dta)} horas atrás`;
            } else {
                dta = dta / 24;
                return `${Math.floor(dta)} dias atrás`;
            }
        }
    },

    GetHours: function (dte) {
        const date = dte instanceof Timestamp ? dte.toDate() : new Date(dte);
        const hours = date.getHours();
        const minutes = date.getMinutes().toString().padStart(2, "0");

        const formatted = `${hours}:${minutes}`;
        return formatted;
    },

    DateIsNear: function (date) {
        let dta = Math.floor(Math.abs(new Date() - new Date(date)) / 1000 / 60);
        return Math.floor(dta);
    },

    IsTodayDate: function (date) {
        let dta = Math.floor(Math.abs(new Date() - new Date(date)) / 1000 / 60);

        if (dta < 60) {
            // return Math.floor(dta); //minutos
            return true;
        } else {
            dta = dta / 60;

            if (Math.floor(dta) <= 12) {
                // return Math.floor(dta); //horas
                return true;
            } else {
                // dta = dta / 24;
                // return Math.floor(dta);//dias
                return false;
            }
        }
    },

    DateTranslate: function (dte) {
        const date = dte instanceof Timestamp ? dte.toDate() : new Date(dte);
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear();
        const hours = date.getHours();
        const minutes = date.getMinutes().toString().padStart(2, "0");

        const formatted = `${day}/${month}/${year} ${hours}:${minutes}`;
        return formatted;
    },

    OnlyDateTranslate: function (dte) {
        const date = dte instanceof Timestamp ? dte.toDate() : new Date(dte);
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear();
        const hours = date.getHours();
        const minutes = date.getMinutes().toString().padStart(2, "0");

        const formatted = `${day}/${month}/${year}`;
        return formatted;
    },

    DateTranslateSimple: function (dte) {
        const date = dte instanceof Timestamp ? dte.toDate() : new Date(dte);
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear();
        const hours = date.getHours();
        const minutes = date.getMinutes().toString().padStart(2, "0");

        const formatted = `${day}/${month} ${hours}:${minutes}`;
        return formatted;
    },

    DateTranslateToInput: function (dte) {
        const date = dte instanceof Timestamp ? dte.toDate() : new Date(dte);
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear();
        const hours = date.getHours();
        const minutes = date.getMinutes().toString().padStart(2, "0");

        const formatted = `${year}-${month}-${day}T12:00`;
        return formatted;
    },

    DateTranslateToTimestamp: function (dte) {
        let s = dte;
        let [dia, mes, ano, hora, minuto] = s.split(/[\/: ]/).map((v) => parseInt(v));

        let data = new Date(ano, mes - 1, dia, hora, minuto);
        return this.DateTranslateToInput(data);
    },

    DateTranslateFromTimestamp: function (dte) {
        var date = new Date(+dte);
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear();
        const formatted = `${day}/${month}/${year}`;

        return formatted;
    },

    GetTimestamp: function (dte) {
        let s = dte;
        let [dia, mes, ano, hora, minuto] = s.split(/[\/: ]/).map((v) => parseInt(v));

        let data = new Date(ano, mes - 1, dia, hora, minuto);
        return data.getTime();
    },

    DateTimeNow: function () {
        const date = new Date();
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear();
        const hours = date.getHours();
        const minutes = date.getMinutes().toString().padStart(2, "0");
        const formatted = `${year}-${month}-${day}T${hours < 10 ? `0${hours}` : hours
            }:${minutes}`;
        return formatted;
    },

    ProcessDates: function (list) {
        for (let s in list) {
            list[s].createdDate = this.DateTranslate(list[s].createdDate);
            list[s].updatedDate = this.DateTranslate(list[s].updatedDate);
        }
        return list;
    },

    ArrayMes: [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
    ],

    getMesExtenso: function (mes) {
        return this.ArrayMes[mes];
    },

    GetMes: function () {
        const dataAtual = new Date();
        const mes = this.getMesExtenso(dataAtual.getMonth());

        return mes;
    },

    GetDia: function () {
        const dataAtual = new Date();
        const dia = dataAtual.getDate();

        return dia;
    },

    GetTerm: function (days) {
        var date = new Date();
        date.setDate(date.getDate() + days);
        return date;
    },

};
